import axios from "axios";
import endpointNames from "../configs/serverUrls";

const baseUrl = endpointNames.commissions;

//gets token from localStorage
// let token = JSON.parse(localStorage.getItem('token'));

const getAllCommissions = async () => {
    let response;
    let token = JSON.parse(localStorage.getItem('token'));
    await axios.get(baseUrl.get, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log("server res: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server: ", err);
            response = err;
        })

    return response;
}

const getAccidentCommissions = async () => {
    let response;
    let token = JSON.parse(localStorage.getItem('token'));
    await axios.get(baseUrl.accident, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log("server res: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server: ", err);
            response = err;
        })

    return response;
}

const getPfumaCommissions = async () => {
    let response;
    let token = JSON.parse(localStorage.getItem('token'));
    await axios.get(baseUrl.pfuma, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log("server res: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server: ", err);
            response = err;
        })

    return response;
}

const getFuneralCommissions = async () => {
    let response;
    let token = JSON.parse(localStorage.getItem('token'));
    await axios.get(baseUrl.funeral, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log("server res: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server: ", err);
            response = err;
        })

    return response;
}

const getSavingsCommissions = async () => {
    let response;
    let token = JSON.parse(localStorage.getItem('token'));
    await axios.get(baseUrl.savings, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log("server res: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server: ", err);
            response = err;
        })

    return response;
}

const getComprehensiveCommissions = async () => {
    let response;
    let token = JSON.parse(localStorage.getItem('token'));
    await axios.get(baseUrl.comprehensive, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log("server res: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server: ", err);
            response = err;
        })

    return response;
}


export default {
    getAllCommissions, getPfumaCommissions,getAccidentCommissions, getFuneralCommissions, getSavingsCommissions, getComprehensiveCommissions
}
